import { translate } from 'components/Translation';
import { BodyS } from 'components/Typography/Typography';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';
import React from 'react';
import { SimType } from 'utils/api/payloads/microApi';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

interface IRemoveConfirmationDialogProps {
	simType: SimType;
	isDialogOpen: boolean;
	hideDialog: () => void;
	deleteCard: () => void;
	loading: boolean;
}

const RemoveConfirmationDialog = ({
	simType,
	isDialogOpen,
	hideDialog,
	deleteCard,
	loading,
}: IRemoveConfirmationDialogProps) => {
	return (
		<ConfirmationDialog
			isOpen={isDialogOpen}
			hideDialog={hideDialog}
			buttons={[
				{
					text: translate('cancel'),
					onClick: hideDialog,
					color: 'tertiary-light',
				},
				{
					text: translate('delete.without.number'),
					onClick: deleteCard,
					color: 'primary-light',
				},
			]}
			header={translate(`numbers.settings.${simType.replace('-', '.')}.delete.dialog.header`)}
			dialogBody={
				<ConditionalRender
					show={loading}
					onTrue={() => <CustomCircularProgress text={''} transparent loading />}
					onFalse={() => (
						<BodyS color="secondary-light">
							{translate(`numbers.settings.${simType.replace('-', '.')}.delete.dialog.body`)}
						</BodyS>
					)}
				/>
			}
		/>
	);
};

export default RemoveConfirmationDialog;
